import React from 'react'

import Button from '@material-ui/core/Button'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

export default function VisibilityDialog ({
  open,
  handleClose,
  handleAccept,
  changeTo
}) {
  const title = `Do you want to change your game visibility to ${changeTo === 'private' ? 'Private' : changeTo === 'friends' ? 'Buddies' : 'Public'}?`
  const text = changeTo === 'public'
    ? 'Changing your Privacy setting to Public means that everyone will be able to see your games if you share the link on e.g. Facebook or Twitter.'
    : changeTo === 'friends'
      ? 'Changing your Privacy setting to Buddies means that only your Buddies will be able to see your games.'
      : 'Changing your Privacy setting to Private means that nobody will be able to see your games, even if you share(d) the link on e.g. Facebook or Twitter.'
  const buttonAgree = changeTo === 'public'
    ? 'Yes, make them Public'
    : changeTo === 'friends'
      ? 'Yes, only for Buddies'
      : 'Yes, make them Private'
  const buttonDisagree = 'No, keep my old privacy setting'

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {buttonDisagree}
        </Button>
        <Button onClick={handleAccept} autoFocus>
          {buttonAgree}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
